var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accessad-page"},[_c('tableComponents',{ref:"tableComponents",attrs:{"pagination":{
      currentPage: _vm.paginationForm.page,
      pageSize: _vm.paginationForm.page_size,
      total: _vm.total,
    },"searchData":_vm.accessadSearchData,"isHaveExport":false,"isHaveAdd":false,"sizes":[10, 20, 50, 100]},on:{"handleCurrentChange":_vm.handleCurrentChange,"handleSizeChange":_vm.handleSizeChange,"sendUserSearch":_vm.getSearch},scopedSlots:_vm._u([{key:"table",fn:function(){return [_c('AccessadTable',{attrs:{"list":_vm.list,"loading":_vm.loading}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }